/* eslint-disable  no-undef  */
import {
  useMediaQuery,
  Box,
  Button,
  Card,
  FormControl,
  Typography,
  InputLabel,
  Select,
  MenuItem,
} from '@mui/material';
import { makeStyles } from '@mui/styles';
import { Refresh as RefreshIcon } from '@mui/icons-material';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import moment from 'moment';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useFirestore } from 'react-redux-firebase';
import { getMonthName } from '../../../utils/utils';
import propTypes from 'prop-types';
import axios from 'axios';
import { actions } from '../../../actions';
import BillTable from './BillTable';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';

import OldBill from './OldBill';
import { isEmpty } from 'lodash';
import collections from '../../../constants/FirestoreCollections';
import { checkInfoAndGenerateRows } from '../helpers';
import ModalBillEmail from './Email/ModalBillEmail';
const projectId = process.env.REACT_APP_PROJECT_ID;
const useStyles = (small) => {
  return makeStyles((theme) => ({
    billingContainer: {
      display: 'flex',
      flexDirection: small ? 'column' : 'row',
    },
    billing: {
      width: '100%',
      maxWidth: '100%',
      padding: 16,
      backgroundColor: '#ffd21f',
    },
    date: {
      width: '200px',
    },
    selectItem: {
      color: theme.palette.black.dark,
      height: '50px',
    },
    selectLabel: {
      fontSize: theme.sizes.sm.t2,
      fontWeight: 'bold',
    },
    buttonsRef: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      gap: '8px',
    },
  }));
};
const BillingV2 = (props) => {
  const { times } = props;

  // define styles
  const small = useMediaQuery('(max-width:600px)');
  const classes = useStyles(small)();
  // states
  const [info, setInfo] = useState({});
  const [lastInfo, setLastInfo] = useState({});
  const [date, setDate] = useState('');
  const [subTotal, setSubTotal] = useState(0);
  const [rows, setRows] = useState([]);
  const [refreshBill, setRefreshBill] = useState(false);
  const [renderBill, setRenderBill] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);

  // redux
  const profile = useSelector((state) => state.firebase.profile);
  const firestore = useFirestore();
  const appDispatch = useDispatch();
  // hooks
  const organization = useSelector((state) => state.app.organization);

  const isAdmin = profile && profile.claims && profile.claims.includes('admin');
  const isFedeorMaca =
    profile &&
    (profile.email === 'federico@prestobots.com' || profile.email === 'mgalvez@prestobots.com'); // Bien hardcodeado pero es para que solo ellos puedan actualizar la factura manualmente hasta que salga la v3

  let totalsRecordatorios = 0;

  const setChargingModal = (boolean) => {
    return appDispatch({
      type: actions.changeLoading,
      loading: { loading: boolean, priority: 1 },
    });
  };
  const setSnackBarAlert = (message, severity) => {
    return appDispatch({
      type: actions.alert,
      alert: {
        snackbarOpen: true,
        snackbarMessage: message,
        snackbarSeverity: severity,
      },
    });
  };

  const handleOpenDBBill = () => {
    window.open(
      `https://console.firebase.google.com/u/0/project/${projectId}/firestore/data/~2Fbills/${info.id}`,
    );
  };
  const generateSubTotal = (rows) => {
    if (rows && rows.length > 0) {
      const sub = rows.reduce((total, row) => {
        if (typeof row.price === 'number') {
          return row.price + total;
        }
        return total;
      }, 0);
      setSubTotal(sub);
    }
  };
  const fetchDataFromFirestore = async () => {
    try {
      if (date !== '' && date._isValid) {
        const billingRes = await firestore
          .collection(collections.bills)
          .where('organizationId', '==', organization.id)
          .where('date', '==', date.format('YYYY-MM'))
          .get();
        if (!billingRes.empty) {
          const bill = { ...billingRes.docs[0].data(), id: billingRes.docs[0].id };
          setInfo(bill);
          localStorage.setItem('prices', JSON.stringify(bill.prices));
          localStorage.setItem('date', JSON.stringify(bill.date));
          localStorage.setItem('isV2', JSON.stringify(bill.isV2 || false));
          localStorage.setItem('isFirstMonth', JSON.stringify(bill.isFirstMonth || false));
          localStorage.setItem(
            'recordatoriosALiquidar',
            JSON.stringify(bill.totalsFromGupshup.totalRecordatorios),
          );
          let isFirstTime = true;
          bill.utility &&
            bill.utility.length > 0 &&
            bill.utility.map((item) => {
              if (item.templateName === null) {
                if (isFirstTime) {
                  totalsRecordatorios += bill.totalsFromGupshup.totalRecordatorios;
                  isFirstTime = false;
                }
              } else {
                totalsRecordatorios += item.notifications;
              }
              localStorage.setItem('totalsRecordatorios', JSON.stringify(totalsRecordatorios));
            });
          bill.utility && localStorage.setItem('utilityTemplates', JSON.stringify(bill.utility));
          localStorage.setItem('prepago', JSON.stringify(bill.prepago || null));
        } else {
          setInfo({});
          localStorage.removeItem('prices');
          localStorage.removeItem('date');
          localStorage.removeItem('isV2');
          localStorage.removeItem('isFirstMonth');
          localStorage.removeItem('prepago');
          localStorage.removeItem('recordatoriosALiquidar');
          localStorage.removeItem('totalsRecordatorios');
          localStorage.removeItem('utilityTemplates');
          setDate('');
          console.log('no se encontro bill');
        }
        const lastBillingRes = await firestore
          .collection(collections.bills)
          .where('organizationId', '==', organization.id)
          .where('date', '==', date.clone().subtract(1, 'month').format('YYYY-MM'))
          .get();
        if (!lastBillingRes.empty) {
          const lastBill = { ...lastBillingRes.docs[0].data(), id: lastBillingRes.docs[0].id };
          setLastInfo(lastBill);
          localStorage.setItem('lastBillPrepago', JSON.stringify(lastBill.prepago || null));
        } else {
          setLastInfo({});
          localStorage.removeItem('lastBillPrepago');
          console.log('no hay last bill'); // seteaba el lastInfo en null
        }
      }
    } catch (err) {
      console.log('Error en useEffect [refreshBill]', err);
    } finally {
      setChargingModal(false);
    }
  };
  useEffect(() => generateSubTotal(rows), [rows]);

  useEffect(() => {
    if (localStorage.getItem('date')) {
      const formatLocalStorageDate = getAndParseLocalStorageDate().replace(
        /(\d{4})-(\d{2})/,
        '$1/$2/01',
      );
      setDate(moment(new Date(formatLocalStorageDate)));
    }
  }, []);

  useEffect(async () => {
    setChargingModal(true);
    if (organization?.id) await fetchDataFromFirestore();
  }, [date, refreshBill, organization]);

  const getAndParseLocalStorageDate = () =>
    localStorage.getItem('date') ? JSON.parse(localStorage.getItem('date')) : false;

  useEffect(() => {
    const dateFromTimes = `${times[0]}`;
    const stringToMoment = dateFromTimes.replace(/(\d{4})-(\d{2})/, '$1/$2/01');
    if ((date === '' || !date._isValid) && getAndParseLocalStorageDate() === false) {
      setDate(moment(new Date(stringToMoment)));
    }
  }, [times]);

  useEffect(() => {
    setRows(checkInfoAndGenerateRows(info, organization.templates));
    // si el objeto info esta vacio, renderBill queda seteado en false, por lo que no renderiza las bill (para evitar errores)
    setRenderBill(!isEmpty(info));
    setChargingModal(false);
  }, [info]);

  useEffect(() => {
    setRenderBill(false);
  }, [organization]);

  const getTime = (time) => {
    const _date = moment(time);
    const month = _date.get('month');
    const year = _date.get('year');
    const monthName = getMonthName(month);
    return `${monthName} ${year}`;
  };
  const handleUpdateBill = () => {
    setChargingModal(true);
    axios(`${process.env.REACT_APP_BILLING_URL}/update-one`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      data: {
        organizationId: organization.id,
        date: `${date.format('YYYY/MM')}/15`,
        requestedBy: profile.email,
      },
    })
      .then((res) => {
        setRefreshBill(!refreshBill);
        setChargingModal(false);
        setSnackBarAlert('Factura actualizada exitosamente', 'success');
      })
      .catch((err) => {
        console.error('Error en handleUpdateBill', err);
        setChargingModal(false);
        setSnackBarAlert('Error al actualizar la factura', 'error');
      });
  };
  return (
    <Box mt={4}>
      <Box display="flex" mb={2} style={{ width: '100%', justifyContent: 'space-between' }}>
        <Box className={classes.date}>
          <FormControl fullWidth>
            <InputLabel>Seleccione período</InputLabel>
            <Select
              value={date !== '' ? date.format('YYYY-MM') : date}
              label="Seleccione período"
              onChange={(e) => {
                setDate(moment(new Date(`${e.target.value.replace('-', '/')}/01`)));
              }}
            >
              {times &&
                times.map((time) => (
                  <MenuItem className={classes.selectItem} key={time} value={time}>
                    {getTime(time)}
                  </MenuItem>
                ))}
            </Select>
          </FormControl>
          {isAdmin && (
            <Typography variant="caption" color="textSecondary">
              Ultima actualizacion:{' '}
              {info && info.updatedAt ? moment(info.updatedAt.toDate()).format('DD/MM/YYYY') : '-'}
            </Typography>
          )}
        </Box>
        {info.isV2 && isAdmin ? (
          <Box className={classes.buttonsRef}>
            {isFedeorMaca && (
              <Button
                startIcon={<RefreshIcon />}
                variant="contained"
                color="primary"
                onClick={handleUpdateBill}
              >
                Actualizar Factura
              </Button>
            )}

            <Button
              startIcon={<OpenInNewIcon />}
              variant="contained"
              className={classes.smallButton}
              onClick={handleOpenDBBill}
            >
              Abrir Factura
            </Button>

            <Button
              startIcon={<MailOutlineIcon />}
              variant="contained"
              color="primary"
              onClick={() => setModalOpen(true)}
            >
              Facturación por correo
            </Button>
          </Box>
        ) : null}
      </Box>
      <Box className={classes.billingContainer}>
        <Card className={classes.billing}>
          {renderBill ? (
            info.isV2 ? (
              <BillTable rows={rows} subTotal={subTotal} prepago={info.prepago} isAdmin={isAdmin} />
            ) : (
              <OldBill info={info} lastInfo={lastInfo} />
            )
          ) : (
            <Typography className={classes.selectLabel} style={{ textAlign: 'center' }}>
              No se encontraron facturas
            </Typography>
          )}
        </Card>
      </Box>
      <ModalBillEmail
        modalOpen={modalOpen}
        setModalOpen={setModalOpen}
        rows={rows}
        subTotal={subTotal}
        prepago={info.prepago}
        billDate={date}
      />
    </Box>
  );
};
const Props = {
  times: propTypes.array,
};
BillingV2.propTypes = Props;
export default BillingV2;
